/**
 * Phone-number formatting. Lives in `shared/` because both the SPA and the
 * Worker-side tests use it, and neither piece touches the DOM.
 */

/** Strip formatting so `tel:` gets something a dialler will accept. */
export function telHref(phoneNumber: string): string {
  const cleaned = phoneNumber.replace(/[^\d+]/g, '');
  return `tel:${cleaned}`;
}

/** Pretty-print a 10- or 11-digit North American number; pass anything else through. */
export function formatPhone(phoneNumber: string): string {
  const digits = phoneNumber.replace(/\D/g, '');
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits.startsWith('1')) {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  return phoneNumber;
}

/**
 * Digits only, for comparing two numbers that are written differently.
 * A leading North American country code is dropped so `+1 425 555 0101` and
 * `(425) 555-0101` are recognised as the same business.
 */
export function normalisePhone(phoneNumber: string): string {
  const digits = phoneNumber.replace(/\D/g, '');
  return digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
}
